import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IOrganizationRegisterState,
  IOrganizationRegister,
  ISoftwareSettingDetail,
} from "./organizationRegisterModel";
import {
  ActiveInactiveOrganization,
  createOrganization,
  deleteOrganization,
  getAllOrganizations,
  getOrganizationByID,
  organizationLogoUpload,
  updateOrganization,
  updateSoftwareSetting,
} from "./services/organizationRegister.services";

const initialState: IOrganizationRegisterState = {
  loading: false,
  settingLoading: false,
  error: "",
  OrganizationList: [],
  OrganizationID: null,
  OrganizationDetail: {
    OrganizationName: "",
    LegalName: "",
    GSTNumber: "",
    PANNumber: "",
    Email: "",
    Phone: "",
    Website: "",
    AddressLine1: "",
    AddressLine2: "",
    City: "",
    State: "",
    Country: "",
    Pincode: "",
    CurrencyCode: "",
    FileName: "",
    LogoImage: "",
    ContactPerson: "",
    ContactMobile: "",
    ContactEmail: "",
    IsActive: 1,
  },
  SoftwareSettingDetail: {
    Crm: false,
    Hotel: false,
    Flight: false,
    Visa: false,
    IsWebsite: false,
  },
};

const organizationRegisterSlice = createSlice({
  name: "organizationRegister",
  initialState,
  reducers: {
    clearOrganizationDetails: (state) => {
      state.OrganizationDetail = initialState.OrganizationDetail;
    },
    setOrganizationID: (state, action: PayloadAction<number>) => {
      state.OrganizationID = action.payload;
    },
    clearOrganizationID: (state) => {
      state.OrganizationID = initialState.OrganizationID;
    },
    setSoftwareSettingDetail: (
      state,
      action: PayloadAction<ISoftwareSettingDetail>,
    ) => {
      state.SoftwareSettingDetail = action.payload;
    },
    clearSoftwareSettingDetail: (state) => {
      state.SoftwareSettingDetail = initialState.SoftwareSettingDetail;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllOrganizations.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllOrganizations.fulfilled,
      (state, action: PayloadAction<IOrganizationRegister[]>) => {
        state.loading = false;
        state.OrganizationList = action.payload || [];
      },
    );
    builder.addCase(getAllOrganizations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.OrganizationList = [];
    });
    builder.addCase(createOrganization.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createOrganization.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createOrganization.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateOrganization.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateOrganization.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateOrganization.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteOrganization.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteOrganization.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteOrganization.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getOrganizationByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getOrganizationByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.OrganizationDetail = action.payload;
    });
    builder.addCase(getOrganizationByID.rejected, (state, action) => {
      state.loading = false;
      state.OrganizationDetail = initialState.OrganizationDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(ActiveInactiveOrganization.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveOrganization.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveOrganization.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(organizationLogoUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(organizationLogoUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(organizationLogoUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateSoftwareSetting.pending, (state) => {
      state.settingLoading = true;
      state.error = "";
    });
    builder.addCase(updateSoftwareSetting.fulfilled, (state) => {
      state.settingLoading = false;
    });
    builder.addCase(updateSoftwareSetting.rejected, (state, action) => {
      state.settingLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearOrganizationDetails,
  clearOrganizationID,
  setOrganizationID,
  clearSoftwareSettingDetail,
  setSoftwareSettingDetail,
} = organizationRegisterSlice.actions;

export default organizationRegisterSlice.reducer;
